// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e3754a31","581":"62662653","613":"54ebb2fa","706":"9739a666"}[chunkId] + ".chunk.js";
};